import { render, staticRenderFns } from "./CheckboxesCard.vue?vue&type=template&id=92ba079a&scoped=true&"
import script from "./CheckboxesCard.vue?vue&type=script&lang=js&"
export * from "./CheckboxesCard.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxesCard.vue?vue&type=style&index=0&id=92ba079a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ba079a",
  null
  
)

export default component.exports